package com.eladfinish.bible.contest.data

import androidx.compose.runtime.Immutable
import com.eladfinish.bible.contest.text.SpannedRange
import com.eladfinish.bible.contest.ui.models.ChapterTextAlign
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf

@Immutable
data class ChapterData(
    val bookIndex: Int? = null,
    val chapterIndex: Int? = null,
    val content: String = "",
    val spannedRangeList: ImmutableList<SpannedRange> = persistentListOf(),
    val textAlign: ChapterTextAlign? = ChapterTextAlign.JUSTIFY,
)
